import { FC } from 'react';

import { Button, ButtonProps } from '@purpur/library';
import { Icon, Size as IconSize } from '@purpur/library/icon';
import { info } from '@purpur/library/icon/assets/info';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import HtmlContent from '@telialt/common-html-content/src/HtmlContent';
import { getPurpurIcon } from '@telialt/common-icon/src/utils';

import { TOOLTIP_SUPPORTED_ICONS } from './constants';
import { Tooltip } from './TooltipInfo.styles';

type TooltipSupportedIcons = (typeof TOOLTIP_SUPPORTED_ICONS)[number];

type TooltipProps = {
    content: string;
    triggerIconSize?: IconSize;
    triggerAreaSize?: ButtonProps['size'];
    triggerAriaLabel?: string;
    icon?: TooltipSupportedIcons;
    className?: string;
    contentClassName?: string;
};

export const TooltipInfo: FC<TooltipProps> = ({
    content,
    triggerIconSize = 'xs',
    triggerAreaSize = 'md',
    triggerAriaLabel,
    icon = 'info',
    className,
    contentClassName,
}) => {
    const { t } = useTranslations();
    const svg = getPurpurIcon(icon) || info;

    return (
        <Tooltip
            align="center"
            position="top"
            className={contentClassName}
            triggerElement={
                <Button
                    className={className}
                    variant="tertiary-purple"
                    size={triggerAreaSize}
                    iconOnly={true}
                    aria-label={triggerAriaLabel ?? t['order_cart.tooltip_trigger_a11y']}
                >
                    <Icon svg={svg} size={triggerIconSize} />
                </Button>
            }
        >
            <HtmlContent isNegative={true} content={content} />
        </Tooltip>
    );
};
